export { default as DetailHero } from './DetailHero';
export { default as DetailHeroFlexibleContent } from './FlexibleContentDetailHero';